// 🔧 qr_code_voting.js
// ✅ Purpose: Marketing landing page wrapper for QR code voting
// ✅ Features:
// - Pulls SEO and page content from centralized marketing_pages.js
// - Renders shared SEO-focused IndustryLandingPage template

import React from "react";
import IndustryLandingPage from "./industry_landing_page";
import { MARKETING_PAGES } from "../../constants/marketing_pages";

const QrCodeVoting = () => {
  return <IndustryLandingPage page={MARKETING_PAGES.qrCodeVoting} />;
};

export default QrCodeVoting;